// extracted by mini-css-extract-plugin
export default {"licenses":"licenses_licenses__e+Xw7","title":"licenses_title__4z9S8","list":"licenses_list__J+uqF","item":"licenses_item__oa+Bd","image":"licenses_image__EV5HE"};